module.exports = __webpack_public_path__ + "img/logo.72871deb.png";